module.exports = __webpack_public_path__ + "img/doctor-service-final.80f0a899.jpg";